import React from 'react'
import ReactDOM from 'react-dom'
import { ApolloClient, InMemoryCache, ApolloProvider } from "@apollo/client";
import Root from 'components/course_view/Root'

document.addEventListener('turbolinks:load', () => {
  const root = document.querySelector("#root");
  const token = document.querySelector('meta[name="csrf-token"]').content;

  if (!!root) {
    const cache = new InMemoryCache({
      typePolicies: {
        Query: {
          fields: {
            fetchQuestions: {
              keyArgs: false,
              merge(existing = [], incoming) {
                return [...existing, ...incoming];
              },
            },
            fetchUsers: {
              keyArgs: false,
              merge(existing = [], incoming) {
                return [...existing, ...incoming];
              },
            },
          },
        },
      },
    });

    const client = new ApolloClient({
      uri: '/graphql',
      cache,
      headers: {
        'X-CSRF-Token': token
      }
    });
    const courseId = root.getAttribute("data-id");

    ReactDOM.render(
      <ApolloProvider client={client} >
        <Root courseId={courseId} />
      </ApolloProvider>,
      root,
    )
  }
})
